/* Quote request form: calculator, persistence and submission to our backend.
   Rendered by sections/main-quote-request.liquid for a product; products without coverage get a manual surface field.
   The calculator mirrors the product page (snippets/product-block-quantity-selector.liquid) exactly:
   same float arithmetic, same coverage source, so the backend's recomputation matches to the cent. */
(function () {
  'use strict';

  var form = document.querySelector('[data-quote-form]');
  if (!form) return;

  var STORAGE_KEY = 'pabp:quote';
  var LABELS = { full_name: 'Nom complet', email: 'Courriel', phone: 'Téléphone', city: 'Ville', message: 'Description du projet', store: 'Magasin', postal_code: 'Code postal' };
  var POSTAL_CODE = /^([A-Za-z]\d[A-Za-z]) ?(\d[A-Za-z]\d)$/;

  var params = new URLSearchParams(window.location.search);
  var alertBox = form.querySelector('[data-quote-alert]');
  var submitButton = form.querySelector('[data-quote-submit]');
  // The product card carries the calculator only when the product has a box coverage.
  var calculator = document.querySelector('[data-quote-calculator]');
  if (calculator && !calculator.querySelector('[data-quote-area]')) calculator = null;
  var manualAreaInput = document.querySelector('[data-quote-manual-area]');
  var figures = null; // what the calculator shows, sent for reconciliation only

  /* ---------- Persistence: the customer can switch product without losing what they typed ---------- */
  function readStorage(key) {
    try { return JSON.parse(window.localStorage.getItem(key)) || null; } catch (error) { return null; }
  }
  function writeStorage(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (error) { /* private mode: ignore */ }
  }
  var persisted = document.querySelectorAll('[data-persist]');
  var saved = readStorage(STORAGE_KEY) || {};

  function saveFields() {
    var state = {};
    persisted.forEach(function (field) { state[field.name] = field.type === 'checkbox' ? field.checked : field.value; });
    writeStorage(STORAGE_KEY, state);
  }
  persisted.forEach(function (field) {
    if (saved[field.name] !== undefined && saved[field.name] !== null) {
      if (field.type === 'checkbox') field.checked = Boolean(saved[field.name]);
      else field.value = saved[field.name];
    }
    field.addEventListener('input', saveFields);
    field.addEventListener('change', saveFields);
  });

  /* ---------- Delivery: the postal code is asked only when the customer wants one ---------- */
  var deliveryBox = form.elements.requires_delivery;
  var deliveryFields = document.querySelector('[data-quote-delivery]');
  var postalCodeInput = document.querySelector('[data-quote-postal-code]');

  function syncDelivery() {
    if (deliveryFields) deliveryFields.hidden = !(deliveryBox && deliveryBox.checked);
  }
  /* Normalized the way the backend stores it, and the way it is written on an envelope: H1A 1A1.
     Empty when the customer typed something that is not a Canadian postal code. */
  function postalCode() {
    var match = postalCodeInput ? POSTAL_CODE.exec(postalCodeInput.value.trim()) : null;
    return match ? (match[1] + ' ' + match[2]).toUpperCase() : '';
  }
  if (deliveryBox) deliveryBox.addEventListener('change', syncDelivery);
  syncDelivery();

  /* ---------- Calculator ---------- */
  var areaInput, wasteInput;
  if (calculator) {
    areaInput = calculator.querySelector('[data-quote-area]');
    wasteInput = calculator.querySelector('[data-quote-waste]');
    var pricePerSqft = parseFloat(calculator.dataset.productPrice);
    var coverage = parseFloat(calculator.dataset.boxCoverage);
    var finalAreaOut = calculator.querySelector('[data-quote-final-area]');
    var boxesOut = calculator.querySelector('[data-quote-boxes]');
    var totalCoverageOut = calculator.querySelector('[data-quote-total-coverage]');
    var priceOut = calculator.querySelector('[data-quote-price]');
  }

  function compute() {
    var area = parseFloat(areaInput.value) || 0;
    var adjusted = area * (wasteInput.checked ? 1.05 : 1.0);
    var boxes = Math.ceil(adjusted / coverage);
    var price = boxes * pricePerSqft * coverage;
    finalAreaOut.textContent = adjusted.toFixed(2);
    boxesOut.textContent = boxes;
    totalCoverageOut.textContent = (boxes * coverage).toFixed(2);
    priceOut.textContent = price.toFixed(2);
    figures = area > 0 ? { surface_sqft: areaInput.value, waste_included: wasteInput.checked, boxes: boxes, price: price.toFixed(2) } : null;
  }

  function readManualSurface() {
    var area = parseFloat(manualAreaInput.value) || 0;
    figures = area > 0 ? { surface_sqft: manualAreaInput.value } : null;
  }

  if (calculator) {
    // Arriving from the product page: its figures win over what the customer typed last time.
    if (params.has('area')) areaInput.value = params.get('area');
    if (params.has('waste')) wasteInput.checked = params.get('waste') === '1';
    areaInput.addEventListener('input', compute);
    wasteInput.addEventListener('change', compute);
    compute();
  } else if (manualAreaInput) {
    if (params.has('area')) manualAreaInput.value = params.get('area');
    manualAreaInput.addEventListener('input', readManualSurface);
    readManualSurface();
  }
  saveFields();

  /* ---------- Ad click ids (same storage keys and 90-day TTL as the rest of the theme) ---------- */
  function clickId(name) {
    var fromUrl = params.get(name);
    if (fromUrl) return fromUrl;
    var record = readStorage('pabp:' + name);
    if (!record || !record.v) return '';
    if (record.d && (Date.now() - record.t) > record.d * 24 * 60 * 60 * 1000) return '';
    return record.v;
  }

  /* ---------- Submission ---------- */
  function showAlert(kind, text, items) {
    alertBox.className = 'form-status__message form-status__message--' + kind + ' quote-request-form__alert';
    alertBox.textContent = text;
    if (items && items.length) {
      var list = document.createElement('ul');
      items.forEach(function (item) { var li = document.createElement('li'); li.textContent = item; list.appendChild(li); });
      alertBox.appendChild(list);
    }
    alertBox.hidden = false;
    alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function validate() {
    var problems = [];
    form.querySelectorAll('.input').forEach(function (field) { field.classList.remove('input--error'); });
    var surfaceInput = calculator ? areaInput : manualAreaInput;
    if (surfaceInput) {
      surfaceInput.classList.remove('input--error');
      if (!(parseFloat(surfaceInput.value) > 0)) {
        surfaceInput.classList.add('input--error');
        problems.push('Surface : entrez la surface à couvrir');
      }
    }
    if (postalCodeInput) {
      if (checked('requires_delivery') && !postalCode()) {
        postalCodeInput.classList.add('input--error');
        problems.push('Code postal : format attendu H1A 1A1');
      }
    }
    Array.prototype.forEach.call(form.elements, function (field) {
      if (field.required && !field.value.trim()) {
        field.classList.add('input--error');
        problems.push((LABELS[field.name] || field.name) + ' : champ requis');
      } else if (field.type === 'email' && field.value && !field.checkValidity()) {
        field.classList.add('input--error');
        problems.push('Courriel : adresse invalide');
      }
    });
    return problems;
  }

  function checked(name) {
    return Boolean(form.elements[name] && form.elements[name].checked);
  }

  function payload() {
    var f = figures || {};
    return {
      product_handle: form.dataset.productHandle || '',
      product_title: form.dataset.productTitle || '',
      surface_sqft: f.surface_sqft || null,
      waste_included: calculator && figures ? f.waste_included : null,
      boxes: f.boxes || null,
      price: f.price || null,
      full_name: form.elements.full_name.value.trim(),
      email: form.elements.email.value.trim(),
      phone: form.elements.phone.value.trim(),
      city: form.elements.city.value.trim(),
      postal_code: postalCode(),
      message: form.elements.message.value.trim(),
      store: form.elements.store.value,
      requires_installation: checked('requires_installation'),
      requires_delivery: checked('requires_delivery'),
      newsletter_opt_in: checked('newsletter_opt_in'),
      gclid: clickId('gclid'),
      fbclid: clickId('fbclid'),
      website: form.elements.website.value
    };
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var problems = validate();
    if (problems.length) { showAlert('error', 'Veuillez corriger les champs suivants :', problems); return; }

    submitButton.disabled = true;
    alertBox.hidden = true;
    var url = form.dataset.backendUrl.replace(/\/$/, '') + '/api/quotes/requests/';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload()) })
      .then(function (response) {
        if (response.status === 202) {
          showAlert('success', '✓ Merci pour votre demande! Nous vous contacterons dans les plus brefs délais.');
          form.reset();
          syncDelivery();
          try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) { /* ignore */ }
          return null;
        }
        if (response.status === 400) {
          return response.json().then(function (errors) {
            var items = Object.keys(errors).map(function (key) {
              return (LABELS[key] || (key === 'non_field_errors' ? 'Demande' : key)) + ' : ' + [].concat(errors[key]).join(' ');
            });
            showAlert('error', 'Veuillez vérifier votre demande :', items);
          });
        }
        throw new Error('HTTP ' + response.status);
      })
      .catch(function () {
        showAlert('error', "Impossible d'envoyer votre demande pour le moment. Réessayez dans quelques minutes, ou appelez directement le magasin de votre choix.");
      })
      .then(function () { submitButton.disabled = false; });
  });
})();
